import axios from 'axios';
import { jsonToFormData } from './utils'

//请求接口的baseUrl
// export const baseRequestUrl ='http://192.168.50.105:9000/'
export const baseRequestUrl ='https://slbsrv.elloworld.cn/'
// export const baseRequestUrl = process.env.NODE_ENV === 'production' ? 'https://slbsrv.elloworld.cn/' : 'http://47.100.174.125:8000/'

const aseKey = 'ello123456789000';

const newkey = CryptoJS.enc.Utf8.parse(aseKey);

//加密
function encrypt (data) {
  const res = CryptoJS.AES.encrypt(data, newkey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  return res.toString()
}

function request(url, params, method) {
  return new Promise ((resolve, reject) => {
    const headers = {
      'Signature': encrypt(new Date().valueOf().toString()),
    }

    const config = {
      method: method || 'get',
      url: baseRequestUrl + url,
      headers
    }

    if (params) {
      if (method && method.toLowerCase() == 'post') {
        config.data = jsonToFormData(params)
        headers['Content-Type'] = 'application/x-www-form-urlencoded'
      } else {
        config.params = params
      }
    }

    config.headers = headers
    
    axios(config).then((res) => {
      let data = res.data

      if (data.error_code == '1000') {
        alert('返回数据为空')
        return
      } else if (data.error_code == '1001') {
        alert('鉴权失败')
        return
      } else if (data.error_code == '1002') {
        alert('参数错误')
        return
      }

      resolve(res)
    }).catch(e => {
      alert(e)
    })
  }).catch(() => {
    alert('错误')
  })
}

export {
  encrypt,
  request
}